module.exports = (__parcel__import__("bjmuG")).then(() => parcelRequire('lmhgI'));